import React, { useState } from "react";

export function ToggleSwitch({
    name,
    checked,
    onChange
}: {
    name: string;
    checked: boolean;
    onChange: (name: string, value: boolean) => void;
}) {
    

  return (
    <button
      onClick={() => onChange(name, !checked)}
      className={`w-8 h-[19px] flex items-center rounded-full p-1 transition-colors duration-300 ${
        checked ? "bg-green-600" : "bg-gray-300"
      }`}
    >
      <div
        className={`w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          checked ? "translate-x-3" : "translate-x-0"
        }`}
      />
    </button>
  );
}
